function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.674781 12.8C0.714781 12.8 0.754781 12.796 0.794781 12.79L4.15878 12.2C4.19878 12.192 4.23678 12.174 4.26478 12.144L12.7428 3.666C12.7613 3.6475 12.776 3.62552 12.7861 3.60133C12.7961 3.57713 12.8013 3.55119 12.8013 3.525C12.8013 3.49881 12.7961 3.47287 12.7861 3.44867C12.776 3.42448 12.7613 3.4025 12.7428 3.384L9.41878 0.058C9.38078 0.02 9.33078 0 9.27678 0C9.22278 0 9.17278 0.02 9.13478 0.058L0.656781 8.536C0.626781 8.566 0.608781 8.602 0.600781 8.642L0.0107811 12.006C-0.00867518 12.1131 -0.00172319 12.2234 0.031035 12.3273C0.0637931 12.4311 0.12137 12.5254 0.198781 12.602C0.330781 12.73 0.496781 12.8 0.674781 12.8ZM2.02278 9.312L9.27678 2.06L10.7428 3.526L3.48878 10.778L1.71078 11.092L2.02278 9.312Z",
  fill: "black"
});

function SvgEditPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit_pencil.e7c75df3.svg";
export { ForwardRef as ReactComponent };